import {
  Box,
  Flex,
  Heading,
  Image,
  List,
  ListIcon,
  ListItem,
  Text,
} from "@chakra-ui/react";
import SponsorCarousel from "../SponsorCarousel";
import { MdCheckCircle } from "react-icons/md";

const About = () => {
  return (
    <Box bg="white" py={[8, 12]}>
      <Box maxW="1400px" mx="auto" px={[4, 6, 8]}>
        <Flex justifyContent="center" mb={6}>
          <Image
            w={["80%", "50%", "35%"]}
            src={`${process.env.PUBLIC_URL}/logo2025.png`}
          />
        </Flex>

        <Heading
          fontSize={["1.6rem", "2rem"]}
          color="green.700"
          mb={1}
          borderLeft="4px solid"
          borderColor="green.400"
          pl={4}
        >
          A Acaol e a Jornada Maçônica
        </Heading>
        <Box w="60px" h="3px" bg="green.400" ml={4} mb={8} borderRadius="2px" />

        <Flex
          flexDir={["column", "column", "row"]}
          gap={[6, 8]}
          alignItems="flex-start"
        >
          <Box
            w={["100%", "100%", "15%"]}
            display="flex"
            justifyContent="center"
            flexShrink={0}
          >
            <SponsorCarousel type="Secundário" />
          </Box>

          <Box flex={1}>
            <Text fontSize="1.05rem" lineHeight={1.8} color="gray.700">
              <Text as="span" display="block" textIndent="1.5em" mb={3}>
                Em fevereiro de 1996, Irmãos de diversas Lojas da Zona Leste de
                São Paulo levantaram duas bandeiras de trabalho:
              </Text>

              <List spacing={3} my={4} ml={4}>
                <ListItem display="flex" alignItems="flex-start" gap={2}>
                  <ListIcon as={MdCheckCircle} color="green.500" mt="2px" flexShrink={0} />
                  <Text>
                    <strong>A Social:</strong> Fundar uma Associação para atender 10 Lojas
                    Maçônicas, construindo 2 Templos com estrutura suficiente para promover
                    trabalhos de Assistência Social e Lazer na região.
                  </Text>
                </ListItem>
                <ListItem display="flex" alignItems="flex-start" gap={2}>
                  <ListIcon as={MdCheckCircle} color="green.500" mt="2px" flexShrink={0} />
                  <Text>
                    <strong>A Cultural:</strong> Organizar um movimento cultural maçônico
                    para os Irmãos da região.
                  </Text>
                </ListItem>
              </List>

              {[
                "Em Janeiro de 1996 foram estabelecidos os fundamentos da Jornada Maçônica e sua 1ª Edição se realizou em setembro do mesmo ano, com sucesso e coroada como um dos Eventos Comemorativos dos 70 anos da Grande Loja Maçônica do Estado de São Paulo.",
                "Contudo, o evento que nasceu para atender as bandeiras social e cultural da região das Lojas da Zona Leste do município de São Paulo, rapidamente se projetou em magnitude estadual e nacional, passando a ser \"Jornada Maçônica de São Paulo\" e, atualmente, \"Jornada Maçônica do Brasil\".",
                "Este alcance foi possível com a participação de Maçons de várias partes do Brasil e do Exterior, com o modelo virtual implementado em sua XXV Edição em setembro de 2022, decorrente da condição imposta pela pandemia que o mundo enfrentou. Mérito e dedicação da equipe de Irmãos organizadores, que em março de 2022, diante da imponderabilidade do que ocorreria em curto e médio prazo, dos lockdown´s impostos para o enfrentamento ao COVID-19, ousaram responder \"SIM, a edição do Jubileu de Prata da Jornada Maçônica do Brasil será realizada. Será conduzida em formato totalmente virtual e que buscará Irmãos Palestrantes e o público maçônico por todo o Brasil.\"",
                "Enfrentando as maiores dificuldades impostas naquele momento, a fé, a perseverança, a capacidade, o comprometimento e a determinação dos componentes da organização tornaram algo, até então inusitado, na XXV Jornada Maçônica do Brasil, sua 1ª Edição 100% Digital.",
                "Seus objetivos precípuos, no entanto, continuam os mesmos: a interação de Maçons de diversas Lojas, Potências e Ritos e a disseminação, através de escritores, profissionais liberais e outros formadores de opinião, oriundos do meio maçônico, de relevantes assuntos internos e externos à Ordem.",
                "Suas metas passam a ser superadas ano a ano com a evolução destes assuntos e crescimento exponencial da cultura maçônica se propagando a todos os espaços do universo.",
                "Esse é o legado que a ACAOL - Associação Cultural e Assistencial Obreiros do Leste construiu e que vem expandindo, agora com uma integração em nível nacional e internacional, sempre com colaboração e participação de estimados e valorosos Irmãos das diversas Unidades da Federação.",
              ].map((paragraph, i) => (
                <Text key={i} textIndent="1.5em" mb={3}>
                  {paragraph}
                </Text>
              ))}

              <Text
                textIndent="1.5em"
                fontWeight={700}
                fontSize="1.15rem"
                color="green.700"
                mt={4}
              >
                Assim, some-se a nós nesta peleja e seja bem-vindo ao nosso portal!
              </Text>
            </Text>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
export default About;
